export { default } from './FineStatusCapsule';



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/FineStatusCapsule/index.js